import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCiSjxag5pjtmZYd37-1VGypVNvUuapef0",
  authDomain: "zhmud-6f313.firebaseapp.com",
  projectId: "zhmud-6f313",
  storageBucket: "zhmud-6f313.firebasestorage.app",
  messagingSenderId: "18799549818",
  appId: "1:18799549818:web:7ed8aa46883f5d0d8dcac3",
  measurementId: "G-GCJ0926XY8"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export function trackPageView(pagePath) {
  logEvent(analytics, 'page_view', { page_path: pagePath });
}

export function trackAddToCart(product) {
  logEvent(analytics, 'add_to_cart', {
    currency: 'EUR',
    value: product.price,
    items: [{ item_id: product.id, item_name: product.name, price: product.price }]
  });
}

export function trackViewItem(product) {
  logEvent(analytics, 'view_item', {
    currency: 'EUR',
    value: product.price,
    items: [{ item_id: product.id, item_name: product.name, price: product.price }]
  });
}

export function trackShopTabSwitch(tabName) {
  logEvent(analytics, 'shop_tab_switch', { tab_name: tabName });
}
